import type { TCustomFieldValue } from './custom-field-value';
import type { TField } from './field';
import type { TMember } from './member';
import type { TOrganization } from './organization';
import type { ValueOf } from './utilities';

export const CUSTOM_FIELD_ENTITIES = {
  application: 'APPLICATION',
  program: 'PROGRAM',
  lead: 'LEAD',
  stage: 'STAGE',
  stageProgress: 'STAGE_PROGRESS',
  rule: 'RULE',
  ruleProgress: 'RULE_PROGRESS',
  task: 'TASK',
  product: 'PRODUCT',
  invoice: 'INVOICE',
  payment: 'PAYMENT',
  placement: 'PLACEMENT',
  placementHostCompany: 'PLACEMENT_HOST_COMPANY',
  university: 'UNIVERSITY',
} as const;

export type TCustomField = {
  id: number;
  name: string;
  label: string;
  entity: ValueOf<typeof CUSTOM_FIELD_ENTITIES>;
  type: TField['type'];
  options: string[];
  order: number;
  organization: TOrganization;
  created_by: TMember;

  value?: TCustomFieldValue;

  created_at: string;
  updated_at: string;
};
